import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EmergencyinfoapiService } from './emergencyinfoapi.service';
import { APIs } from 'src/app/config/api.constant';
import { AppConstant } from '../config/app.constant';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../environments/environment';
const baseUrl = `${environment.apiBaseUrlVegitation}api/`;

@Injectable({
  providedIn: 'root'
})
export class AddemergencyinfoService {
  url: string;
  accessToken: any;
  token_type: any;
  token: string;
  excelContent: any;

  constructor(private apiService: EmergencyinfoapiService, private http: HttpClient) {

  }

  createEmergencyInfo(body?: any): Observable<any> {
    return this.apiService.post(APIs.saveEmergencyInfo, body).pipe(map(response => {
      return response;
    }));
  }

  updateEmergencyInfo(body?: any): Observable<any> {
    return this.apiService.put(APIs.updateEmergencyInfo, body).pipe(map(response => {
      return response;
    }));
  }
}